import {
  editorDataFunction,
  componentInstanceData,
} from '@wix/editor-component-data-resolver';
import type { EditorAPI } from '#packages/editorAPI';
import experiments from 'experiment';

import type { ComponentEditorMetaDataDefinition } from '../types';

const girdVisibleAlignmentMap: Record<string, (props: AnyFixMe) => boolean> = {
  nineGrid(popupContainerProperties) {
    return popupContainerProperties.horizontalAlignment === 'center';
  },
  fullWidth() {
    return true;
  },
  fullHeight() {
    return false;
  },
};

export const isPopupSelectable = (editorAPI: EditorAPI): boolean => {
  const isTpaPopupNotSelectable = experiments.isOpen(
    'se_tpaPopupNotSelectable',
  );

  if (!isTpaPopupNotSelectable) {
    return true;
  }

  const popupPages = editorAPI.pages.popupPages.getCurrentPopupData();
  if (popupPages?.managingAppDefId) {
    const appData = editorAPI.platform.getAppDataByAppDefId(
      popupPages?.appDefinitionId,
    );
    const isLightboxExtention = appData?.components?.find(
      //TODO: add type UnifiedLightbox to UnifiedAppComponents in dm
      // @ts-expect-error
      (comp) => comp.data?.base.id === popupPages?.tpaPageId,
    );
    if (isLightboxExtention) {
      return false;
    }
  }

  return true;
};

const metaData: ComponentEditorMetaDataDefinition = {
  selectable: isPopupSelectable,
  pinnable: false,
  gridLinesVisible: editorDataFunction(
    componentInstanceData('componentProperties'),
    (popupContainerProperties: AnyFixMe) => {
      const isGridVisibleFn =
        girdVisibleAlignmentMap[popupContainerProperties.alignmentType];

      if (isGridVisibleFn) {
        return isGridVisibleFn(popupContainerProperties);
      }
    },
  ),
  focusable: true,
};

export default metaData;
